import { DiscountsForm } from 'components/discounts/DiscountsForm/DiscountsForm'

export const DiscountsCreate: React.FC = () => {
  return <DiscountsForm mode='create' />
}
